var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C3.89543 4 3 4.89543 3 6V16C3 17.1046 3.89543 18 5 18H17C18.1046 18 19 17.1046 19 16V6C19 4.89543 18.1046 4 17 4H5ZM8.7124 14.6062C8.7124 15.0481 9.07057 15.4062 9.5124 15.4062C9.95423 15.4062 10.3124 15.0481 10.3124 14.6062L10.3124 7.39375C10.3124 6.95192 9.95423 6.59375 9.5124 6.59375C9.07057 6.59375 8.7124 6.95192 8.7124 7.39375V14.6062ZM6.5124 15.4062C6.07057 15.4062 5.7124 15.0481 5.7124 14.6062V12.2052C5.7124 11.7633 6.07057 11.4052 6.5124 11.4052C6.95423 11.4052 7.3124 11.7633 7.3124 12.2052V14.6062C7.3124 15.0481 6.95423 15.4062 6.5124 15.4062ZM14.7437 14.6062C14.7437 15.0481 15.1018 15.4062 15.5437 15.4062C15.9855 15.4062 16.3437 15.0481 16.3437 14.6062V12.2052C16.3437 11.7633 15.9855 11.4052 15.5437 11.4052C15.1018 11.4052 14.7437 11.7633 14.7437 12.2052V14.6062ZM12.5124 15.4062C12.0706 15.4062 11.7124 15.0481 11.7124 14.6062V9.72349C11.7124 9.28166 12.0706 8.92349 12.5124 8.92349C12.9542 8.92349 13.3124 9.28166 13.3124 9.72349V14.6062C13.3124 15.0481 12.9542 15.4062 12.5124 15.4062Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartResultIcon);
export default __webpack_public_path__ + "static/media/ChartResultIcon.9181aa03ec1ed3e200bd522d4fdf905d.svg";
export { ForwardRef as ReactComponent };